import localforage from 'localforage';
import { atom } from 'recoil';
import localForageEffect from '../../store/recoil/effects/localForageEffect';

export const getIsNavigatorOpenFromIndexedDb = async (): Promise<boolean> => {
  const isNavigatorOpen = await localforage.getItem<boolean>('isNavigatorOpen');
  if (isNavigatorOpen === null) {
    return true;
  }
  return isNavigatorOpen;
};

export const filterStringAtom = atom<string>({
  key: 'filterString',
  default: '',
});

export const filteredVehiclesAtom = atom<number[]>({
  key: 'filteredVehicles',
  default: [],
});

export const isOpenAtom = atom<boolean>({
  key: 'isOpen',
  default: getIsNavigatorOpenFromIndexedDb(),
  effects: [localForageEffect('isNavigatorOpen')],
});

export const isNavigatorDisabledAtom = atom<boolean>({
  key: 'isDisabled',
  default: false,
});

export const showLoaderAtom = atom<boolean>({
  key: 'showLoader',
  default: false,
});

export const showVehiclesAtom = atom<boolean>({
  key: 'showVehicles',
  default: true,
});

export const showVehicleGroupsAtom = atom<boolean>({
  key: 'showVehicleGroups',
  default: false,
});
export const isMinimalizedCarsIconsAtom = atom<boolean>({
  key: 'isMinimalizedCarsIcons',
  default: false,
});
